function f(r, t, n) {
  if (r === "error" && t)
    return t;
  if (r === "warning" && n)
    return n;
}
export {
  f as g
};
//# sourceMappingURL=get-status-message-CGqgCpjJ.mjs.map
